import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, BookOpen } from 'lucide-react';
export function SolutionSection() {
  const scrollToPurchase = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 bg-gray-50" data-id="element-166">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-167">
        <div className="text-center mb-16" data-id="element-168">
          <span className="text-[#1B5E20] font-bold tracking-wider uppercase text-sm" data-id="element-169">
            La Solución Definitiva
          </span>
          <h2 className="text-4xl md:text-5xl font-black text-[#0F172A] mt-2 mb-6" data-id="element-170">
            MegaPack Educación Física LISTA™
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-171">
            Un megapack completo creado para que tengas todo tu año de Educación
            Física organizado, estructurado y resuelto sin volver a empezar
            desde cero nunca más.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-12 bg-white rounded-3xl shadow-xl p-8 md:p-12 border border-gray-100" data-id="element-172">
          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="flex-1 cursor-pointer" onClick={scrollToPurchase} data-id="element-173">
            <img src="https://cdn.magicpatterns.com/uploads/1YUtJDJVs1ZKhrEJoXRy3i/1_COVER.png" alt="MegaPack Libro Principal" className="w-full h-auto rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300" data-id="element-174" />
          </motion.div>

          {/* Content */}
          <div className="flex-1" data-id="element-175">
            <div className="flex items-center gap-3 mb-6" data-id="element-176">
              <BookOpen className="w-8 h-8 text-[#1B5E20]" data-id="element-177" />
              <h3 className="text-3xl font-bold text-[#0F172A]" data-id="element-178">
                Libro principal
              </h3>
            </div>

            <h4 className="text-xl font-semibold text-[#1B5E20] mb-6" data-id="element-179">
              MegaPack Educación Física LISTA™
            </h4>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8" data-id="element-180">
              {['Planificación anual lista', 'Clases organizadas paso a paso', 'Actividades motrices variadas', 'Juegos adaptables a distintos espacios', 'Propuestas claras y aplicables', 'Material práctico, real y usable'].map((item, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="flex items-start gap-3" data-id="element-181">
                  <CheckCircle2 className="w-5 h-5 text-[#1B5E20] flex-shrink-0 mt-0.5" data-id="element-182" />
                  <span className="text-gray-700 font-medium" data-id="element-183">{item}</span>
                </motion.div>)}
            </div>

            <div className="bg-[#F59E0B]/10 border border-[#F59E0B] rounded-lg p-6 text-center" data-id="element-184">
              <p className="text-[#0F172A] font-bold text-lg" data-id="element-185">
                Todo pensado para que entres al aula sabiendo exactamente qué
                hacer.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}